import { EntityManager, Repository } from "aurelia-orm";
//import { ItemTypeBase } from "core/item-type-base";
import { AppEntity } from "../entities/app-entity";


export class EntityService<T extends AppEntity> {

    repository: Repository;

    constructor(entityClass: any, private entityManager: EntityManager) {
        this.repository = entityManager.getRepository(entityClass.name);
    }

    listTrashed(parentId: number): Promise<Array<T>> {
        return this.repository.find('list-trashed?parentId=' + parentId);
    }

    listArchived(parentId: number): Promise<Array<T>> {
        return this.repository.find('list-archived?parentId=' + parentId);
    }

    save(T) {
        return this.repository.find("save");
    }

    getNew(): T {
        return this.repository.getNewEntity();
    }

    listActive(parentId: number): Promise<Array<T>> {
        return this.repository.find("list-active?parentId=" + parentId);
    }

}